import React from "react"
import { SearchspringSuggestResponse } from "@app/scripts/lib/searchspring"

export function SearchDrawerMenu({
  showNoResults,
  title,
  noResults,
  response,
}: {
  showNoResults?: boolean
  title?: string
  noResults?: string
  response?: SearchspringSuggestResponse
}) {
  const terms: string[] = []
  const seen = new Set<string>()
  const push = (text?: string) => {
    if (!text) return
    const key = text.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    terms.push(text)
  }

  // suggested.text is the primary completion. When type === "exact" it just
  // echoes the user's query so we skip it; corrections and completions
  // (type "completed" / "fallback") are useful to surface.
  if (response?.suggested && response.suggested.type !== "exact") {
    push(response.suggested.text)
  }
  for (const alt of response?.alternatives ?? []) push(alt.text)

  return (
    <div className="search-drawer--menu-container">
      {showNoResults ? (
        <p className="search-drawer--menu-no-results">{noResults}</p>
      ) : (
        <>
          <h3 className="search-drawer--menu-title">{title}</h3>
          <div className="search-drawer--menu-items-container">
            {terms.map((term) => (
              <a
                key={term}
                href={`/search?query=${encodeURIComponent(term)}`}
                className="search-drawer--menu-item"
              >
                {term.toLowerCase()}
                <span className="search-drawer--menu-item-underline"></span>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
